<div class="tile-container {{isLast ? 'last' : ''}} {{getHeaderStyle()}}" (click)="showHideInfoSection()">
  <div class="col-12">
    <div class="row">
      <div class="col-4 date">
        <div class="row">
          <div class="status-block {{getStyle()}}">
          </div>

          {{renderDates()}}
        </div>
      </div>
      <div class="col-6">
        <a class="title-hyperlink" href="/company_events/{{event.companyEvent.id}}" target="_blank">{{event.companyEvent.title}}</a>
      </div>
      <div class="col-2">
        <div class="row title">
          <div class="col-10">
            @if (event.companyEvent.companyEventAttendees.length > 0) {
              <div><i class="material-icons attendee-icon">person</i><strong style="vertical-align: middle">{{event.companyEvent.companyEventAttendees.length}}</strong></div>
            }
          </div>
          <div class="col-1">
            @if (getStatusCount()>0) {
              <div>
                @if (event.companyEvent.is_sponsored) {
                  <i class="material-icons in-line-icon">diamond</i>
                }
                @if (event.companyEvent.is_cosponsored) {
                  <i class="material-icons in-line-icon">groups</i>
                }
                @if (event.companyEvent.is_postponed) {
                  <i class="material-icons in-line-icon">warning</i>
                }
                @if (event.companyEvent.is_cancelled) {
                  <i class="material-icons target-warning">warning</i>
                }
              </div>
            }
          </div>
          <div class="col-1">
            @if (!showInfoBar) {
              <i class="material-icons" style="font-size: 14px; color: lightgray; opacity: .9">arrow_drop_down</i>
            }
            @if (showInfoBar) {
              <i class="material-icons" style="font-size: 14px; color: lightgray; opacity: .9">arrow_drop_up</i>
            }
          </div>
        </div>
      </div>
    </div>
    @if (showInfoBar) {
      <div class="row tile-info-section divider">
        <mat-divider></mat-divider>
      </div>
    }
    @if (showInfoBar) {
      <div class="row tile-info-section">
        @for (val of renderEventInfo(); track val) {
          <div class="info-{{val.key}}">
            @if (val.key=='location') {
              @for (address of val.value; track address) {
                <div class="row">
                  <span><strong>{{address.name}}: </strong>{{address.address}}</span>
                </div>
              }
            }
            @if (val.key=='type') {
              <div class="row">{{val.value}}</div>
            }
            @if (val.key=='registered') {
              <div class="row"><strong>Registered</strong></div>
              @for (person of val.value; track person) {
                <div class="row">
                  <span>
                    {{person.person.name}}
                  </span>
                </div>
              }
            }
            @if (val.key=='unregistered') {
              <div class="row"><strong>Unregistered</strong></div>
              @for (person of val.value; track person) {
                <div class="row">
                  <span>{{person.person.name}}</span>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</div>
